import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { LifeEvents } from "@/components/LifeEvents";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Certifications } from "@/components/Certifications";
import { Process } from "@/components/Process";
import { Reference } from "@/components/Reference";
import { SmejdTeaser } from "@/components/SmejdTeaser";
import { ToolsSection } from "@/components/ToolsSection";
import { Faq } from "@/components/Faq";
import { Institutions } from "@/components/Institutions";
import { BookingSection } from "@/components/BookingSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <About />
        <Certifications />
        <Process />
        <SmejdTeaser />
        <Reference />
        <LifeEvents />
        <ToolsSection />
        <Faq />
        <Institutions />
        <BookingSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
